import styled from "@emotion/styled";
import { Button, IconArrow } from "atoms";
import { useLocation, useNavigate } from "react-router-dom";
import { paths } from "utils/paths";

/**
 * This component is a weird work in progress with no technical spec.
 * Maybe it shouldn't even exist?
 */

type PortfolioBackButtonProps = {
  itemId?: string;
  artistId: string;
  galleryId?: string;
  isEditing?: boolean;
};
function GalleryBackButton({
  itemId,
  artistId,
  galleryId,
  isEditing,
}: PortfolioBackButtonProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const goBack = () => {
    const path: string = location.state?.from.pathname;
    // if you came from a portfolio page, go back to it
    // if (location.key === "default") {
    //   navigate(paths.artistPortfolio(artistId));
    // }
    if (path && path.includes(paths.artistPortfolio(artistId))) {
      return navigate(path);
    }
    // if you came from ... anywhere ... go back to it
    return navigate(-1);
  };
  return (
    <BackButton size="xs" variant="blank" aria-label="Back" onClick={goBack}>
      <IconArrow dir="l" aria-hidden /> Back
    </BackButton>
  );
}

const BackButton = styled(Button)({
  borderColor: "transparent",
  justifyContent: "flex-start",
  gap: 6,
  "&&:hover, &&:focus-visible": { borderColor: "transparent" },
});

export { GalleryBackButton };
